/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import { Card, Tooltip, Icon } from '@scuf/common';
import descriptors from '../../../../../../locales/en-US/descriptors';
import {
  IDetailComponentPropsSeparateAPI,
  IEmaasEnergyUsageComponentData
} from '../../../../../DashboardKPIWidgets/IEnergyManagementProps';
import ConnectionError from '../../../../../shared/ErrorComponents/ConnectionError';
import withErrorStatus from '../../../../../shared/StatusWrappers/ErrorStatus';
import withLoadingStatus from '../../../../../shared/StatusWrappers/LoadingStatus';
import { isObjectOrArrayAndEmpty } from '../../../../../shared/Utils/Utils';
import { GetHeader } from '../../../../../shared/Utils/PortfolioEnergy/PortfolioEnergyVDUtils';
import {
  EmaasSubscriptionType,
  EnergyUsageDataSourceType,
  EnergyUsageField
} from '../../../../../shared/Enums';
import EmaasEUsageAllUtilDetailsBasicComponent from '../../../../EnergyUsagesViewDetailsWidget/AllUtilitiesDetails/EmaasEUsageAllUtilDetailsBasicComponent';
import PortfolioEnergyTopComponentSeparate from './PortfolioEnergyTopComponentSeparate';
import { ApiContext } from '../../../../../../context/ApiContext';

interface ITotalEmissionTabDetailsComponentProps {
  data: IEmaasEnergyUsageComponentData;
  onRefresh: () => Promise<void>;
  tabName?: string;
  forGraph?: boolean;
  forSummary?: boolean;
}
const PortfolioEnergyAllUtilitiesDetailContent = (
  props: ITotalEmissionTabDetailsComponentProps
) => {
  const { data, onRefresh } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  if (isObjectOrArrayAndEmpty(data)) {
    return (
      <div className="errorDisplay">
        <ConnectionError
          onRefresh={onRefresh}
          title={t(d.CONNECTIONERRORTITLE)}
          message={t(d.CONNECTIONERROR)}
        />
      </div>
    );
  }
  return (
    <div className="carbondetail-performance-detail-container">
      <div>
        {data.subscriptionType === EnergyUsageField.BASICSUBS ? (
          <EmaasEUsageAllUtilDetailsBasicComponent data={data} />
        ) : (
          <PortfolioEnergyTopComponentSeparate
            forSummary={props.forSummary}
            forGraph={props.forGraph}
            tabName={props.tabName}
            data={data}
          />
        )}
      </div>
    </div>
  );
};

const PortfolioEnergyAllUtilitiesDetailWithLoader = withLoadingStatus(
  withErrorStatus(PortfolioEnergyAllUtilitiesDetailContent)
);

const PortfolioEnergyTopWidgetHOCSeprate = (
  props: IDetailComponentPropsSeparateAPI
) => {
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  const {
    dataConnector,
    tabName,
    dataConnectorPerformanceAggregation,
    requestContext
  } = props;
  const apiContext = useContext(ApiContext);
  const {
    enableWaterUsageDashboards,
    enableConsumptionSourceSelect,
    cemsIntervalEnergySourceOption
  } = apiContext;

  const { dataSourceType } = apiContext;

  const onRefreshPerf = () =>
    dataConnectorPerformanceAggregation &&
    dataConnectorPerformanceAggregation.actions &&
    dataConnectorPerformanceAggregation.actions.getAll();

  const onRefresh = () =>
    dataConnector && dataConnector.actions && dataConnector.actions.getAll();

  const allPerf = dataConnectorPerformanceAggregation.data.all;
  const loadingPerf = dataConnectorPerformanceAggregation.data.loading;
  const errorPerf = dataConnectorPerformanceAggregation.data.error;
  const statusPerf = dataConnectorPerformanceAggregation.data.status;

  const PerformanceData = (allPerf as unknown) as IEmaasEnergyUsageComponentData;
  let isDataAvailableForPerfromance: boolean;
  if (PerformanceData.sourceType === 'Water') {
    isDataAvailableForPerfromance =
      PerformanceData && PerformanceData.monthWiseAggregations ? true : false;
  } else {
    isDataAvailableForPerfromance =
      PerformanceData && PerformanceData.performanceAggregation ? true : false;
  }

  const { all, loading, error, status } = dataConnector.data;
  const electricitySavings = (all as unknown) as IEmaasEnergyUsageComponentData;
  const isDataAvailable =
    electricitySavings && electricitySavings.summary ? true : false;

  const [isLoading, setIsLoading] = useState<boolean>(loading);
  const [isLoadingPerf, setIsLoadingPerf] = useState<boolean>(loadingPerf);
  const [statusCode, setStatusCode] = useState<number | null>(0);
  const [errorInfo, setErrorInfo] = useState(errorPerf);
  const [statusCodePerf, setStatusCodePerf] = useState<number | null>(0);
  const [errorInfoPerf, setErrorInfoPerf] = useState(errorPerf);
  const [data, setData] = useState({} as IEmaasEnergyUsageComponentData);
  const [dataPerf, setDataPerf] = useState(
    {} as IEmaasEnergyUsageComponentData
  );
  const [currentTab, setCurrentTab] = useState<string>('energy');
  useEffect(() => {
    setIsLoadingPerf(loadingPerf);
    if (
      isDataAvailableForPerfromance ||
      errorPerf ||
      statusPerf ||
      !loadingPerf
    ) {
      if (isDataAvailableForPerfromance) {
        let tempData: any = PerformanceData;
        tempData.summary = {};
        setDataPerf(tempData);
      }
      setErrorInfoPerf(errorPerf);
      setStatusCodePerf(statusPerf);
    }
  }, [isDataAvailableForPerfromance, loadingPerf, statusPerf]);

  useEffect(() => {
    setIsLoading(loading);

    if (isDataAvailable || error || status || !loading) {
      if (isDataAvailable) {
        let tempData = electricitySavings;
        setData(tempData);
      }
      setErrorInfo(error);
      setStatusCode(status);
    }
  }, [isDataAvailable, loading, status]);
  console.log(
    'enableConsumptionSourceSelect11',
    enableConsumptionSourceSelect,
    dataSourceType
  );
  const header = GetHeader(tabName);
  return (
    <>
      <Card className="emaas-performance-detail-card">
        <Card.Header>
          <div className="emaas-summary-card-header">
            <span>{t(header)}</span>
            <Tooltip
              element={
                <Icon
                  root="common"
                  name="badge-info"
                  exactSize="0.875rem"
                  className="emaas-summary-card-header-info-icon"
                />
              }
              event="hover"
              content={
                // tabName === 'allutilities'
                data.subscriptionType === EnergyUsageField.BASICSUBS
                  ? t(d.EMAASPORTFOLIOENERGYUSAGETOOLTIPPREV)
                  : enableConsumptionSourceSelect
                  ? dataSourceType === EnergyUsageDataSourceType.UTILITY_METER
                    ? t(d.CEMSPORTFOLIO_DATA_SOURCE_UTIL_TOOLTIP)
                    : dataSourceType ===
                      EnergyUsageDataSourceType.UTILITY_INTERVAL
                    ? t(d.CEMSPORTFOLIO_DATA_SOURCE_INTERVAL_TOOLTIP)
                    : enableWaterUsageDashboards && props.tabName === 'water'
                    ? t(d.CEMSPORTFOLIO_DATA_SOURCE_LIVE_WATER_TOOLTIP)
                    : t(d.CEMSPORTFOLIO_DATA_SOURCE_LIVE_TOOLTIP)
                  : enableWaterUsageDashboards
                  ? t(d.EMAASPORTFOLIOCONSUMPTIONTOOLTIP)
                  : t(d.EMAASPORTFOLIOENERGYUSAGETOOLTIP)
              }
              position="right center"
              size="small"
              header={t(header)}
            />
          </div>
        </Card.Header>
        {statusCode == 204 || statusCodePerf == 204 ? (
          <Card.Content className="detail-summary-card detail-view">
            <PortfolioEnergyAllUtilitiesDetailWithLoader
              loading={isLoading}
              error={errorInfo}
              statusCode={statusCode}
              onRefresh={onRefresh}
              data={data}
              loadingText={t(d.LOADING)}
              title={t(d.CONNECTIONERRORTITLE)}
              noDataMessage={t(d.NODATAAVAILABLE)}
              connectionErrorMessage={t(d.CONNECTIONERROR)}
              tabName={tabName}
              forSummary={true}
            />
          </Card.Content>
        ) : (
          <>
            <Card.Content className="detail-summary-card detail-view">
              <PortfolioEnergyAllUtilitiesDetailWithLoader
                loading={isLoading}
                error={errorInfo}
                statusCode={statusCode}
                onRefresh={onRefresh}
                data={data}
                loadingText={t(d.LOADING)}
                title={t(d.CONNECTIONERRORTITLE)}
                noDataMessage={t(d.NODATAAVAILABLE)}
                connectionErrorMessage={t(d.CONNECTIONERROR)}
                tabName={tabName}
                forSummary={true}
              />
            </Card.Content>
            <Card.Content className="detail-summary-card detail-view">
              <PortfolioEnergyAllUtilitiesDetailWithLoader
                loading={isLoadingPerf}
                error={errorInfoPerf}
                statusCode={statusCodePerf}
                onRefresh={onRefreshPerf}
                data={dataPerf}
                loadingText={t(d.LOADING)}
                title={t(d.CONNECTIONERRORTITLE)}
                noDataMessage={t(d.NODATAAVAILABLE)}
                connectionErrorMessage={t(d.CONNECTIONERROR)}
                tabName={tabName}
                forGraph={true}
              />
            </Card.Content>
          </>
        )}
      </Card>
    </>
  );
};
export default PortfolioEnergyTopWidgetHOCSeprate;
